import { postingFilterLabels } from '~/utils/postingFilters';
import uuidv4 from '~/utils/uuidv4';
import convertFilterLabel from '~/utils/convertFilterLabel';
import i18n from '~/i18n';

import sessionId from '~/utils/sessionId';

import { getSubDomain } from '~/utils/urlUtils';
import { DEFAULT_DOMAIN } from '~/services/UniversityService';

import { getJsonFromUrl } from '../../utils/urlUtils';

// Gets the id of a nameId (projects/<Project-Id>/<Id>)
export const parseId = nameId => {
    const splitJobId = (nameId || '').split('/');
    return splitJobId[splitJobId.length - 1];
};

const first = arr => {
    return arr && arr.length > 0 ? arr[0] : null;
};

const extractCompanyLogo = job => {
    const customAttributes = job.customAttributes || {};
    return customAttributes.company_logo &&
        customAttributes.company_logo.stringValues &&
        customAttributes.company_logo.stringValues.length > 0
        ? customAttributes.company_logo.stringValues[0]
        : null;
};

const extractJobAdId = job => {
    const customAttributes = job.customAttributes || {};
    return customAttributes.job_id &&
        customAttributes.job_id.stringValues &&
        customAttributes.job_id.stringValues.length > 0
        ? customAttributes.job_id.stringValues[0]
        : null;
};

// Template: [templateName, templateDescription, paginationConfig]
// paginationConfig must be an object with atleast one field (nextPageQuery)
// which has to be a function that returns an object that will be merged
// into the query(url) when a new query is requested, the function is passed
// pageInfo, that is another field paginationConfig can use, pageInfo is passed
// a api result object, same as entry, and can return anything that could help
// nextPageQuery to figure out want the wanted page is.

const safeGet = (item, value, orReturn) => {
    if (item) {
        return value !== null && value !== undefined && item[value] ? item[value] : orReturn;
    } else return orReturn;
};

export default {
    // baseURL: 'http://127.0.0.1:8080/api/v1/',
    staticQuery: store => {
        let userKey = safeGet(Object.keys(store.state.user.data), 0, undefined);
        let user = safeGet(store.state.user.data, userKey, undefined);
        let user_id = safeGet(user, 'id', undefined);
        let temp = {
            session_id: sessionId,
            job_set: 'all',
            sub_domain: getSubDomain() || DEFAULT_DOMAIN,
        };
        if (user_id) {
            temp.user_id = user_id;
        }
        return temp;
    },
    entry: res => {
        return res.data.matchingJobs || [];
    },
    template: [
        'posting_template',
        (data, _, res) => {
            // Parsing data
            const job = data.job || data;
            const locations = (job.derivedInfo || {}).locations || [];
            const locationInfo =
                ((locations.length > 0 ? locations[0].postalAddress : {}) || {}).addressLines || {};

            const locality = locations.length > 0 ? locations[0].postalAddress.locality : null;

            let country = (locationInfo[0] || '').split(',').pop();
            country = country ? country.split('-').pop() : null;

            const location = locationInfo.length > 0 ? locationInfo[0] : null;
            const shortLocation =
                locationInfo.length > 0 ? (locality ? locality + ',' + country : location) : null;
            const parsedId = parseId(job.name);
            const customAttributes = job.customAttributes || {};

            let tempLabels = [];
            // if (job.promotionValue > 0) {
            //     tempLabels.push({ text: 'Featured', tooltip: 'This post is payed for and featured' })
            // }

            return {
                id: parsedId,
                jobAdId: extractJobAdId(job),

                deadline: job.postingExpireTime,
                description: job.description,
                title: job.title,
                location: location,
                shortLocation: shortLocation,

                promotionValue: job.promotionValue,

                labels: IS_PROD
                    ? []
                    : Math.random() < 0.3
                    ? [
                          {
                              type: 'img',
                              text: i18n.t('gptw.posting.label.alt'),
                              tooltip: i18n.t('gptw.posting.label.tooltip'),
                              img:
                                  'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcR8bNFI1aiRnfl9fsyywxu1R_D1heD7RsMZ1MDqzA-ATpX-N2dK',
                          },
                          ...tempLabels,
                      ]
                    : [],

                nameId: job.name,

                companyId: customAttributes.company_id.stringValues[0],
                companyName: job.companyDisplayName,
                companyLogo: extractCompanyLogo(job),
                companyDescription: data.company_description,

                // USED FOR EVENTS
                requestId:
                    (res && res.data && res.data.metadata && res.data.metadata.requestId) || '',
                eventId: sessionId + res.data.nextPageToken,
            };
        },
        {
            pageInfo: res => {
                let reqParams = getJsonFromUrl(res.request.responseURL);
                let page = parseInt(reqParams.page);
                if (page && page > 0) {
                    return {
                        nextPage: page + 1,
                        length: (res.data.matchingJobs || []).length,
                    };
                }
                return {
                    next: res.data.nextPageToken,
                    length: (res.data.matchingJobs || []).length,
                };
            },
            nextPageQuery: prev => {
                if (prev.length == 0) {
                    return false;
                }
                if (prev.nextPage) {
                    return { page: prev.nextPage };
                }
                if (!prev.next) {
                    return false;
                }
                return { page_token: prev.next };
            },
        },
    ],

    GET: {
        authorize: true,
        queryInfo: (res, queryRoute) => {
            const eventId = sessionId + queryRoute;
            return {
                estimatedJobsLeft: res.data.estimatedTotalSize,
                eventId: eventId,
            };
        },
        action: async res => {
            const event = require('~/main.js').default.$interfaces.event;
            if (!res.data.matchingJobs) return;
            event.post({
                body: {
                    requestId: res.data.metadata.requestId,
                    eventId: 'JobsListImpression' + uuidv4(),
                    createTime: new Date().toISOString(),
                    jobEvent: {
                        type: 'IMPRESSION',
                        jobs: res.data.matchingJobs.map(it => it.job.name),
                    },
                },
            });
        },
    },
    '/:id': {
        GET: 'detail',
        entry: data => data.data,
        template: [
            'POSTING_TEMPLATE',
            data => {
                const derivedInfo = data.derivedInfo || {};
                const applicationLink = first((data.applicationInfo || {}).uris || []);
                const address = first(data.addresses || []);
                return {
                    id: parseId(data.name),
                    jobAdId: extractJobAdId(data),
                    title: data.title,
                    description: data.description,
                    deadline: data.postingExpireTime,
                    link: applicationLink,
                    location: address,

                    nameId: data.name,
                    languages: safeGet(data.customAttributes, 'languages', {
                        stringValues: [],
                    }).stringValues,

                    employmentTypes: (data.employmentTypes || []).map(e =>
                        i18n.t(`cts.employmentTypes.${e}`)
                    ),
                    preferedEducationFields: (derivedInfo.jobCategories || []).map(e =>
                        i18n.t(`cts.educationFields.${e}`)
                    ),
                    preferedEducationLevels: (data.degreeTypes || []).map(e =>
                        i18n.t(`cts.educationLevels.${e}`)
                    ),

                    gptw: IS_PROD
                        ? null
                        : {
                              text: i18n.t('gptw.posting.detail.alt'),
                              tooltip: `<h5 class="white">${i18n.t(
                                  'gptw.posting.detail.tooltip.isCertified',
                                  { companyName: data.companyDisplayName }
                              )}</h5> <p class="white"></p>${i18n.t(
                                  'gptw.posting.detail.tooltip.description'
                              )}<p class="white">${i18n.t(
                                  'gptw.posting.detail.tooltip.readMore'
                              )}</p>`,
                              img:
                                  'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcR8bNFI1aiRnfl9fsyywxu1R_D1heD7RsMZ1MDqzA-ATpX-N2dK',
                          },

                    companyId: data.customAttributes.company_id.stringValues[0],
                    companyName: data.companyDisplayName,
                };
            },
        ],
    },

    '/filters': {
        template: [
            'FILTER_TEMPLATE',
            data => {
                // Converts filters to correct form of an object with
                // a label (filterName), value (the key the backend accepts),
                // and options (an array with the filter in form of {value, label})
                const filters = Object.keys(data).map(key => ({
                    label: postingFilterLabels[key],
                    value: key,
                    options: data[key].map(e => ({
                        value: e,
                        label: convertFilterLabel(e),
                    })),
                }));

                return { id: 1, filters };
            },
        ],
        GET: 'filters',
    },
};
